import {CasinofiedZoidApplicationAdapter} from "./casinofied-zoid-application-adapter";
import {IAppClosedTopicPayload, IDivHostedAppInitParameters} from "@sparkware/uc-sdk-core";

export class UnifiedCashierZoidAdapter extends CasinofiedZoidApplicationAdapter {

    private _onCloseAlreadyCalled: Record<string, boolean> = {};
    protected _onClose(payload: IAppClosedTopicPayload, initParams: IDivHostedAppInitParameters) {
        const appID = payload?.appID || this.appID;

        if(this._onCloseAlreadyCalled[appID]) { // unified cashier is calling twice this method. The second time is without payload. Adrian Parsan is saying that is something related to zoid
            this._onCloseAlreadyCalled[appID] = false;
        } else {
            this._onCloseAlreadyCalled[appID] = true;
            this.applicationSdk.close(appID);
            super._onClose({
                ...payload,
                appID: appID
            }, initParams);
        }
    }
}